import { cloneDeep } from "lodash";

import { Event, EventDispatcher } from "lib/EventDispatcher";

import { ApiHelper } from "./ApiHelper";

export class Http {

	// parameters = { name: value }, ie. { id: 1, name: "Bob" }
	//////////////////////////////
	//// NOTE: This method will return ANY successful response as a successful request
	////       It is up to the calling methods to know if a given response should be
	////          identified as successful or not.
	////       For example, an endpoing which return an HTML error page will be returned
	////          as successful, and the calling method must be able to determine that
	////          an error actually occurred.
	//////////////////////////////
	public static httpGet = async (uri: string, parameters?: object): Promise<Response> => {

		// Check for parameters
		if (parameters) {

			// Append query string onto Uri
			uri += ApiHelper.buildQueryString(parameters);
		}

		// Attempt to make request
		try {

			// Make request
			const response: Response = await Http.makeRequest(uri, {

				method: "GET",
				headers: { Accept: "*/*" },
				mode: "cors",
				credentials: "include",
			});

			// Return reponse
			return response;
		}
		catch (e) {

			// Re-throw error
			throw e;
		}
	}

	// data = { name: value }, ie. { id: 1, name: "Bob" }
	//////////////////////////////
	//// NOTE: This method will return ANY successful response as a successful request
	////       It is up to the calling methods to know if a given response should be
	////          identified as successful or not.
	////       For example, an endpoing which return an HTML error page will be returned
	////          as successful, and the calling method must be able to determine that
	////          an error actually occurred.
	//////////////////////////////
	public static httpPost = async (uri: string, data?: object | string): Promise<Response> => {

		// Build headers
		const headers: any = { Accept: "*/*" };

		// Initialize body
		let body: any = "";

		// Check for data and ensure it is an object
		if (data) {

			// Add content type header
			headers["Content-Type"] = "application/json";

			// Create Clone Object (One With Can Be Adjusted)
			const record = cloneDeep(data);

			// Add processed data to body
			body = JSON.stringify(record);
		}

		// Attempt to make request
		try {

			// Make request
			const response: Response = await Http.makeRequest(uri, {

				method: "POST",
				headers,
				mode: "cors",
				body,
				credentials: "include",
			});

			// Return response
			return response;
		}
		catch (e) {

			// Re-throw error
			throw e;
		}
	}

	// data = { name: value }, ie. { id: 1, name: "Bob" }
	//////////////////////////////
	//// NOTE: This method will return ANY successful response as a successful request
	////       It is up to the calling methods to know if a given response should be
	////          identified as successful or not.
	////       For example, an endpoing which return an HTML error page will be returned
	////          as successful, and the calling method must be able to determine that
	////          an error actually occurred.
	//////////////////////////////
	public static httpPut = async (uri: string, data: object): Promise<Response> => {

		// Build headers
		const headers: any = { Accept: "*/*" };

		// Initialize body
		let body = "";

		// Add content type header
		headers["Content-Type"] = "application/json";

		// Create Clone Object (One With Can Be Adjusted)
		const record = cloneDeep(data);

		// Add data to body
		body = JSON.stringify(record);

		// Attempt to make request
		try {

			// Make request
			const response: Response = await Http.makeRequest(uri, {

				method: "PUT",
				headers,
				mode: "cors",
				body,
				credentials: "include",
			});

			// Return response
			return response;
		}
		catch (e) {

			// Re-throw error
			throw e;
		}
	}

	//////////////////////////////
	//// NOTE: This method will return ANY successful response as a successful request
	////       It is up to the calling methods to know if a given response should be
	////          identified as successful or not.
	////       For example, an endpoing which return an HTML error page will be returned
	////          as successful, and the calling method must be able to determine that
	////          an error actually occurred.
	//////////////////////////////
	public static httpDelete = async (uri: string, data?: object | string): Promise<any | any[]> => {

		// Build headers
		const headers: any = { Accept: "*/*" };

		// Attempt to make request
		try {

			// Initialize Response
			let response: Response;

			// Check Data
			if (data !== undefined) {

				// Create Clone Object (One With Can Be Adjusted)
				const record = cloneDeep(data);

				// Add data to body
				const body = JSON.stringify(record);

				// Add content type header
				headers["Content-Type"] = "application/json";

				// Make request
				response = await Http.makeRequest(uri, {

					method: "DELETE",
					headers,
					mode: "cors",
					credentials: "include",
					body,
				});
			}
			else {

				// Make request
				response = await Http.makeRequest(uri, {

					method: "DELETE",
					headers,
					mode: "cors",
					credentials: "include"
				});
			}

			// Return response
			return response;
		}
		catch (e) {

			// Re-throw error
			throw e;
		}
	}

	public static makeRequest = async (uri: string, configuration: RequestInit): Promise<Response> => {

		// Attempt To Make Request
		try {

			// Initialize Response
			let response: Response;

			// Make Request
			response = await fetch(uri, configuration);

			// Check For Unauthorized
			if (response.status === 401) {

				// Trigger Unauthorized Event
				EventDispatcher.dispatch(Event.Unauthorized);
			}

			// Return Response
			return response;
		}
		catch (e) {

			// Re-Throw Error
			throw e;
		}
	}
}
